// Detailed field schemas for each document type.
// Each field: { key, label, type(text|textarea|date|number|select|list|check), options?, rows?, full?, section? }

const signatureFields = [
  { key: "signed_date", label: "署名日", type: "date" },
  { key: "client_name", label: "利用者氏名(署名)", type: "text" },
  { key: "representative_name", label: "代理人氏名", type: "text" },
  { key: "representative_relation", label: "代理人続柄", type: "text" },
  { key: "provider_signer", label: "事業所側説明/署名者", type: "text" },
  { key: "client_signature", label: "利用者・代理人 署名", type: "signature", full: true },
  { key: "provider_signature", label: "事業所 署名", type: "signature", full: true },
];

export const DOC_SCHEMAS = {
  // === 申込・契約 ===
  application: {
    sections: [
      { title: "申込情報", fields: [
        { key: "application_date", label: "申込日", type: "date" },
        { key: "referrer", label: "紹介元(医療機関・ケアマネ等)", type: "text" },
        { key: "referrer_contact", label: "紹介元連絡先", type: "text" },
        { key: "start_desired_date", label: "サービス開始希望日", type: "date" },
        { key: "service_type", label: "希望サービス区分", type: "select", options: ["介護保険", "医療保険", "精神科訪問看護", "予防訪問看護"] },
        { key: "frequency", label: "訪問頻度希望", type: "text" },
        { key: "purpose", label: "訪問看護を希望する理由・目的", type: "textarea", rows: 3, full: true },
        { key: "current_condition", label: "現在の状況", type: "textarea", rows: 3, full: true },
        { key: "urgency", label: "緊急度", type: "select", options: ["通常", "早急", "緊急"] },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  important_matters: {
    sections: [
      { title: "事業所概要(自動差し込み)", note: "事業所情報から自動反映されます" },
      { title: "サービス内容", fields: [
        { key: "service_description", label: "提供サービス内容", type: "textarea", rows: 4, full: true },
        { key: "staff_composition", label: "職員体制", type: "textarea", rows: 2, full: true },
        { key: "business_area", label: "実施地域", type: "text", full: true },
      ]},
      { title: "料金", fields: [
        { key: "fee_care_insurance", label: "介護保険適用(1割〜3割)", type: "textarea", rows: 2, full: true },
        { key: "fee_medical_insurance", label: "医療保険適用", type: "textarea", rows: 2, full: true },
        { key: "fee_self_pay", label: "自費項目(交通費等)", type: "textarea", rows: 2, full: true },
        { key: "cancel_policy", label: "キャンセル時の料金", type: "textarea", rows: 2, full: true },
      ]},
      { title: "緊急時対応", fields: [
        { key: "emergency_contact", label: "24時間緊急連絡先", type: "text" },
        { key: "emergency_hours", label: "緊急対応時間帯", type: "text" },
        { key: "emergency_policy", label: "緊急時の対応方針", type: "textarea", rows: 3, full: true },
      ]},
      { title: "秘密保持・個人情報", fields: [
        { key: "privacy_policy", label: "個人情報取扱い方針", type: "textarea", rows: 3, full: true },
      ]},
      { title: "苦情対応", fields: [
        { key: "complaint_window", label: "苦情相談窓口", type: "text", full: true },
        { key: "complaint_third_party", label: "第三者評価機関", type: "text", full: true },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  contract: {
    sections: [
      { title: "契約概要", fields: [
        { key: "contract_date", label: "契約日", type: "date" },
        { key: "contract_start", label: "契約開始日", type: "date" },
        { key: "contract_end", label: "契約終了日", type: "date" },
        { key: "contract_period_note", label: "契約期間の備考(自動更新等)", type: "textarea", rows: 2, full: true },
      ]},
      { title: "契約内容", fields: [
        { key: "service_content", label: "サービス内容", type: "textarea", rows: 4, full: true },
        { key: "frequency_time", label: "訪問頻度・時間", type: "textarea", rows: 2, full: true },
        { key: "fee_total", label: "料金(月額目安)", type: "text" },
        { key: "payment_method", label: "支払方法", type: "select", options: ["口座引き落とし", "銀行振込", "現金"] },
      ]},
      { title: "解除・変更", fields: [
        { key: "termination_conditions", label: "契約解除条件", type: "textarea", rows: 3, full: true },
        { key: "penalty_policy", label: "違約事項", type: "textarea", rows: 2, full: true },
      ]},
      { title: "責任", fields: [
        { key: "liability", label: "損害賠償責任", type: "textarea", rows: 3, full: true },
        { key: "insurance", label: "損害賠償保険加入状況", type: "text", full: true },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  // === 同意書 ===
  consent_pi: {
    sections: [
      { title: "個人情報の利用", fields: [
        { key: "purposes", label: "利用目的", type: "textarea", rows: 5, full: true },
        { key: "third_party_sharing", label: "第三者提供先(主治医・多職種等)", type: "textarea", rows: 3, full: true },
        { key: "retention_period", label: "保管期間", type: "text", full: true },
        { key: "withdrawal_policy", label: "同意撤回の手続き", type: "textarea", rows: 2, full: true },
      ]},
      { title: "同意項目", fields: [
        { key: "agree_internal_share", label: "1. 事業所内での情報共有に同意する", type: "check" },
        { key: "agree_doctor_share", label: "2. 主治医との情報共有に同意する", type: "check" },
        { key: "agree_multidisciplinary", label: "3. 多職種(ケアマネ・介護職等)との情報共有に同意する", type: "check" },
        { key: "agree_family", label: "4. 家族への情報提供に同意する", type: "check" },
        { key: "agree_research", label: "5. 匿名化した上での研究利用に同意する", type: "check" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  consent_emergency: {
    sections: [
      { title: "緊急時対応の同意", fields: [
        { key: "consent_scope", label: "同意する対応範囲", type: "textarea", rows: 4, full: true },
        { key: "emergency_visit", label: "緊急訪問に同意する", type: "check" },
        { key: "ambulance_call", label: "必要時の救急搬送要請に同意する", type: "check" },
        { key: "doctor_contact", label: "主治医への緊急連絡に同意する", type: "check" },
        { key: "family_contact", label: "家族への緊急連絡に同意する", type: "check" },
      ]},
      { title: "緊急連絡先", fields: [
        { key: "doctor_name", label: "主治医氏名", type: "text" },
        { key: "doctor_phone", label: "主治医連絡先", type: "text" },
        { key: "family_contact1", label: "家族連絡先①", type: "text" },
        { key: "family_contact2", label: "家族連絡先②", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  consent_medical_share: {
    sections: [
      { title: "医療情報共有", fields: [
        { key: "sharing_partners", label: "共有先(病院・診療所・多職種)", type: "textarea", rows: 3, full: true },
        { key: "shared_info", label: "共有する情報の範囲", type: "textarea", rows: 4, full: true },
        { key: "purpose", label: "共有目的", type: "textarea", rows: 3, full: true },
        { key: "agree_sharing", label: "上記の医療情報共有に同意する", type: "check" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  // === 計画・アセスメント ===
  service_plan: {
    sections: [
      { title: "基本情報", fields: [
        { key: "plan_date", label: "作成日", type: "date" },
        { key: "plan_author", label: "作成者", type: "text" },
        { key: "plan_period_start", label: "計画期間 開始", type: "date" },
        { key: "plan_period_end", label: "計画期間 終了", type: "date" },
      ]},
      { title: "利用者基本情報", fields: [
        { key: "living_situation", label: "居住状況・家族構成", type: "textarea", rows: 3, full: true },
        { key: "life_history", label: "生活歴・社会背景", type: "textarea", rows: 3, full: true },
        { key: "main_diagnosis_detail", label: "主病名・現病歴", type: "textarea", rows: 3, full: true },
        { key: "adl_summary", label: "ADL・IADL状況", type: "textarea", rows: 3, full: true },
        { key: "cognitive", label: "認知機能", type: "textarea", rows: 2, full: true },
      ]},
      { title: "サービス計画", fields: [
        { key: "goal", label: "長期目標", type: "textarea", rows: 2, full: true },
        { key: "short_goal", label: "短期目標", type: "textarea", rows: 2, full: true },
        { key: "service_details", label: "サービス内容詳細", type: "textarea", rows: 4, full: true },
        { key: "frequency", label: "訪問頻度・時間", type: "text", full: true },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  assessment: {
    sections: [
      { title: "アセスメント基本", fields: [
        { key: "assess_date", label: "アセスメント日", type: "date" },
        { key: "assess_type", label: "区分", type: "select", options: ["初回", "再評価", "臨時"] },
        { key: "assessor", label: "評価者", type: "text" },
      ]},
      { title: "健康状態", fields: [
        { key: "medical_condition", label: "主病名・現病歴", type: "textarea", rows: 3, full: true },
        { key: "medications_detail", label: "服薬状況", type: "textarea", rows: 3, full: true },
        { key: "vitals_baseline", label: "バイタル基準値", type: "text", full: true },
        { key: "pain", label: "疼痛の有無・部位", type: "textarea", rows: 2, full: true },
      ]},
      { title: "身体機能・ADL", fields: [
        { key: "movement", label: "移動・移乗", type: "textarea", rows: 2, full: true },
        { key: "eating", label: "食事・栄養", type: "textarea", rows: 2, full: true },
        { key: "excretion", label: "排泄", type: "textarea", rows: 2, full: true },
        { key: "bathing", label: "清潔・入浴", type: "textarea", rows: 2, full: true },
        { key: "sleep", label: "睡眠", type: "textarea", rows: 2, full: true },
      ]},
      { title: "コミュニケーション・認知", fields: [
        { key: "communication", label: "コミュニケーション能力", type: "textarea", rows: 2, full: true },
        { key: "cognitive_function", label: "認知機能・精神状態", type: "textarea", rows: 3, full: true },
      ]},
      { title: "環境・社会", fields: [
        { key: "family_support", label: "家族の介護力・支援状況", type: "textarea", rows: 3, full: true },
        { key: "housing", label: "住環境", type: "textarea", rows: 2, full: true },
        { key: "social_resources", label: "利用中の社会資源", type: "textarea", rows: 2, full: true },
      ]},
      { title: "課題・ニーズ", fields: [
        { key: "problems", label: "健康上の課題", type: "textarea", rows: 3, full: true },
        { key: "needs", label: "本人・家族のニーズ", type: "textarea", rows: 3, full: true },
        { key: "nursing_direction", label: "看護の方針", type: "textarea", rows: 3, full: true },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  care_plan_draft: {
    sections: [
      { title: "計画書(案)", fields: [
        { key: "plan_date", label: "作成日", type: "date" },
        { key: "plan_author", label: "作成者", type: "text" },
        { key: "plan_period_start", label: "計画期間 開始", type: "date" },
        { key: "plan_period_end", label: "計画期間 終了", type: "date" },
      ]},
      { title: "看護目標", fields: [
        { key: "long_goal", label: "長期目標", type: "textarea", rows: 2, full: true },
        { key: "short_goal", label: "短期目標", type: "textarea", rows: 2, full: true },
      ]},
      { title: "看護内容", fields: [
        { key: "nursing_content", label: "看護内容・ケア内容", type: "textarea", rows: 6, full: true },
        { key: "frequency", label: "訪問頻度・時間", type: "text", full: true },
        { key: "special_management", label: "特別管理項目", type: "textarea", rows: 2, full: true },
      ]},
      { title: "評価", fields: [
        { key: "evaluation_plan", label: "評価時期・方法", type: "textarea", rows: 2, full: true },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  care_plan_final: {
    sections: [
      { title: "計画書(本)", fields: [
        { key: "plan_date", label: "作成日", type: "date" },
        { key: "plan_author", label: "作成者(担当看護師)", type: "text" },
        { key: "plan_approver", label: "承認者(管理者)", type: "text" },
        { key: "plan_period_start", label: "計画期間 開始", type: "date" },
        { key: "plan_period_end", label: "計画期間 終了", type: "date" },
      ]},
      { title: "看護目標", fields: [
        { key: "long_goal", label: "長期目標", type: "textarea", rows: 2, full: true },
        { key: "short_goal", label: "短期目標", type: "textarea", rows: 2, full: true },
      ]},
      { title: "看護内容", fields: [
        { key: "nursing_content", label: "看護内容・ケア内容", type: "textarea", rows: 6, full: true },
        { key: "frequency", label: "訪問頻度・時間", type: "text", full: true },
        { key: "special_management", label: "特別管理項目", type: "textarea", rows: 2, full: true },
        { key: "collaboration", label: "多職種連携内容", type: "textarea", rows: 2, full: true },
      ]},
      { title: "評価", fields: [
        { key: "evaluation_plan", label: "評価時期・方法", type: "textarea", rows: 2, full: true },
      ]},
      { title: "同意", fields: [
        { key: "consent_received", label: "利用者・家族の同意を得た", type: "check" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  care_plan_psych: {
    sections: [
      { title: "精神科訪問看護計画書", fields: [
        { key: "plan_date", label: "作成日", type: "date" },
        { key: "plan_author", label: "作成者", type: "text" },
        { key: "plan_period_start", label: "計画期間 開始", type: "date" },
        { key: "plan_period_end", label: "計画期間 終了", type: "date" },
      ]},
      { title: "精神症状・状態", fields: [
        { key: "psych_symptoms", label: "精神症状", type: "textarea", rows: 3, full: true },
        { key: "gaf_score", label: "GAF評価スコア(直近)", type: "number" },
        { key: "phq9_score", label: "PHQ-9スコア(直近)", type: "number" },
        { key: "medication_adherence", label: "服薬アドヒアランス", type: "textarea", rows: 2, full: true },
      ]},
      { title: "目標・ケア内容", fields: [
        { key: "long_goal", label: "長期目標", type: "textarea", rows: 2, full: true },
        { key: "short_goal", label: "短期目標", type: "textarea", rows: 2, full: true },
        { key: "care_content", label: "ケア内容(精神科訪問看護の視点)", type: "textarea", rows: 6, full: true },
        { key: "family_support_plan", label: "家族支援", type: "textarea", rows: 2, full: true },
        { key: "crisis_plan", label: "危機対応計画", type: "textarea", rows: 3, full: true },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  // === 会議・連携 ===
  service_meeting: {
    sections: [
      { title: "会議情報", fields: [
        { key: "meeting_date", label: "開催日", type: "date" },
        { key: "meeting_time", label: "開催時間", type: "text" },
        { key: "meeting_place", label: "開催場所", type: "text" },
        { key: "organizer", label: "主催者(ケアマネ等)", type: "text" },
      ]},
      { title: "参加者", fields: [
        { key: "participants", label: "参加者一覧(氏名・所属・職種)", type: "textarea", rows: 4, full: true },
      ]},
      { title: "議題・内容", fields: [
        { key: "agenda", label: "議題", type: "textarea", rows: 2, full: true },
        { key: "current_status", label: "現在の状況報告", type: "textarea", rows: 4, full: true },
        { key: "discussions", label: "検討事項・協議内容", type: "textarea", rows: 6, full: true },
        { key: "decisions", label: "決定事項", type: "textarea", rows: 4, full: true },
        { key: "next_meeting", label: "次回予定", type: "text", full: true },
      ]},
      { title: "記録者", fields: [
        { key: "recorder", label: "記録者", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  meeting_other: {
    sections: [
      { title: "会議記録", fields: [
        { key: "meeting_date", label: "開催日", type: "date" },
        { key: "meeting_type", label: "会議種別", type: "text" },
        { key: "participants", label: "参加者", type: "textarea", rows: 3, full: true },
        { key: "agenda", label: "議題", type: "textarea", rows: 2, full: true },
        { key: "discussions", label: "協議内容", type: "textarea", rows: 6, full: true },
        { key: "decisions", label: "決定事項", type: "textarea", rows: 4, full: true },
        { key: "recorder", label: "記録者", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  discharge_coop: {
    sections: [
      { title: "退院時共同指導", fields: [
        { key: "discharge_date", label: "退院日", type: "date" },
        { key: "cooperation_date", label: "共同指導実施日", type: "date" },
        { key: "hospital", label: "病院名", type: "text" },
        { key: "hospital_doctor", label: "病院主治医", type: "text" },
        { key: "ward", label: "病棟", type: "text" },
      ]},
      { title: "内容", fields: [
        { key: "disease_progress", label: "入院中の経過", type: "textarea", rows: 4, full: true },
        { key: "current_condition", label: "退院時の状態", type: "textarea", rows: 4, full: true },
        { key: "care_points", label: "在宅移行時のケアポイント", type: "textarea", rows: 4, full: true },
        { key: "medications", label: "退院処方", type: "textarea", rows: 3, full: true },
        { key: "care_instructions", label: "指導内容", type: "textarea", rows: 4, full: true },
      ]},
      { title: "参加者", fields: [
        { key: "participants", label: "参加者(病院・在宅双方)", type: "textarea", rows: 3, full: true },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  multidisciplinary: {
    sections: [
      { title: "多職種連携記録", fields: [
        { key: "contact_date", label: "連携日時", type: "date" },
        { key: "contact_method", label: "連携方法", type: "select", options: ["電話", "FAX", "メール", "対面", "ICT", "書面"] },
        { key: "partner_name", label: "連携先(氏名)", type: "text" },
        { key: "partner_org", label: "連携先所属", type: "text" },
        { key: "partner_role", label: "連携先職種", type: "text" },
        { key: "content", label: "連携内容", type: "textarea", rows: 5, full: true },
        { key: "follow_up", label: "フォローアップ必要事項", type: "textarea", rows: 2, full: true },
        { key: "reporter", label: "記録者", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  // === 記録・報告 ===
  monitoring: {
    sections: [
      { title: "モニタリング", fields: [
        { key: "monitor_date", label: "評価日", type: "date" },
        { key: "period_start", label: "評価対象期間 開始", type: "date" },
        { key: "period_end", label: "評価対象期間 終了", type: "date" },
        { key: "evaluator", label: "評価者", type: "text" },
      ]},
      { title: "目標の達成状況", fields: [
        { key: "long_goal_status", label: "長期目標の達成度", type: "textarea", rows: 3, full: true },
        { key: "short_goal_status", label: "短期目標の達成度", type: "textarea", rows: 3, full: true },
      ]},
      { title: "変化の評価", fields: [
        { key: "physical_change", label: "身体面の変化", type: "textarea", rows: 3, full: true },
        { key: "mental_change", label: "精神面の変化", type: "textarea", rows: 3, full: true },
        { key: "adl_change", label: "ADL変化", type: "textarea", rows: 3, full: true },
        { key: "family_change", label: "家族・環境の変化", type: "textarea", rows: 3, full: true },
      ]},
      { title: "今後の方針", fields: [
        { key: "continuation", label: "継続するケア", type: "textarea", rows: 3, full: true },
        { key: "modification", label: "修正・変更するケア", type: "textarea", rows: 3, full: true },
        { key: "plan_revision", label: "計画書の見直し要否", type: "select", options: ["継続(変更なし)", "一部修正", "全面見直し"] },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  nursing_report: {
    sections: [
      { title: "報告書基本", fields: [
        { key: "report_date", label: "報告日", type: "date" },
        { key: "report_to", label: "宛先(主治医)", type: "text" },
        { key: "period_start", label: "報告期間 開始", type: "date" },
        { key: "period_end", label: "報告期間 終了", type: "date" },
        { key: "visit_count", label: "訪問回数", type: "number" },
      ]},
      { title: "利用状況", fields: [
        { key: "health_status", label: "病状・健康状態", type: "textarea", rows: 4, full: true },
        { key: "vital_summary", label: "バイタル経過", type: "textarea", rows: 3, full: true },
        { key: "adl_status", label: "ADL状況", type: "textarea", rows: 3, full: true },
        { key: "mental_status", label: "精神状態", type: "textarea", rows: 3, full: true },
      ]},
      { title: "看護ケア内容", fields: [
        { key: "nursing_care", label: "実施した看護ケア", type: "textarea", rows: 5, full: true },
        { key: "observation", label: "観察事項・所見", type: "textarea", rows: 4, full: true },
      ]},
      { title: "評価・提案", fields: [
        { key: "evaluation", label: "評価", type: "textarea", rows: 3, full: true },
        { key: "suggestion", label: "主治医への依頼・提案", type: "textarea", rows: 3, full: true },
      ]},
      { title: "記載者", fields: [
        { key: "author", label: "記載者(看護師名)", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  opinion: {
    sections: [
      { title: "意見書 基本情報", fields: [
        { key: "issue_date", label: "作成日", type: "date" },
        { key: "case_no", label: "案件番号", type: "text" },
        { key: "opinion_kind", label: "意見区分", type: "select", options: ["医療連携意見", "介護保険意見", "制度・行政", "事故・苦情対応", "その他"] },
        { key: "addressee", label: "宛先(医療機関・行政・関係機関)", type: "text", full: true },
        { key: "subject", label: "件名", type: "text", full: true },
      ]},
      { title: "意見内容", fields: [
        { key: "background", label: "背景・経緯", type: "textarea", rows: 4, full: true },
        { key: "content", label: "意見・提案内容", type: "textarea", rows: 8, full: true },
        { key: "supporting_facts", label: "根拠となる観察事実・データ", type: "textarea", rows: 4, full: true },
        { key: "expected_outcome", label: "期待される結果", type: "textarea", rows: 3, full: true },
        { key: "request_action", label: "宛先への要望・依頼事項", type: "textarea", rows: 3, full: true },
      ]},
      { title: "作成者", fields: [
        { key: "author", label: "作成者(職種・氏名)", type: "text" },
        { key: "author_title", label: "役職", type: "text" },
        { key: "approver", label: "承認者(管理者)", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  instruction_request: {
    sections: [
      { title: "依頼区分", fields: [
        { key: "request_type", label: "区分", type: "select", options: ["新規", "継続"] },
        { key: "request_date", label: "依頼年月日", type: "date" },
        { key: "receiver_handler", label: "依頼受理担当者", type: "text" },
      ]},
      { title: "宛先(医療機関・主治医)", fields: [
        { key: "medical_institution", label: "医療機関名", type: "text" },
        { key: "department", label: "診療科", type: "text" },
        { key: "doctor_name", label: "主治医名", type: "text" },
        { key: "doctor_honorific", label: "敬称", type: "text" },
      ]},
      { title: "本文", fields: [
        { key: "greeting_body", label: "依頼文", type: "textarea", rows: 4, full: true },
      ]},
      { title: "対象者情報", fields: [
        { key: "patient_kana", label: "フリガナ", type: "text" },
        { key: "patient_name", label: "患者氏名", type: "text" },
        { key: "patient_birth", label: "生年月日", type: "text" },
        { key: "patient_gender", label: "性別", type: "text" },
        { key: "patient_address", label: "住所", type: "text", full: true },
        { key: "patient_phone", label: "電話番号", type: "text" },
      ]},
      { title: "依頼内容", fields: [
        { key: "req_nursing_instruction", label: "訪問看護指示書", type: "check" },
        { key: "req_iv_instruction", label: "在宅患者訪問点滴注射指示書", type: "check" },
        { key: "req_special_instruction", label: "特別訪問看護指示書", type: "check" },
        { key: "purpose", label: "利用目的", type: "text", full: true },
        { key: "instruction_start_date", label: "訪問看護指示開始日", type: "date" },
        { key: "visit_content", label: "訪問内容", type: "text" },
      ]},
      { title: "自立支援医療(該当時)", fields: [
        { key: "req_self_support_cert", label: "自立支援医療受給者証(精神通院医療)診断書依頼書", type: "check" },
        { key: "self_support_type", label: "区分", type: "select", options: ["新規", "更新"] },
        { key: "self_support_limit", label: "期限", type: "date" },
        { key: "self_support_cert_needed", label: "診断書", type: "select", options: ["要", "不要"] },
        { key: "req_self_support_add", label: "自立支援医療機関追加用意見書依頼書(訪問看護)", type: "check" },
      ]},
    ],
  },

  other_record: {
    sections: [
      { title: "その他記録", fields: [
        { key: "record_date", label: "記録日", type: "date" },
        { key: "category", label: "カテゴリ", type: "text" },
        { key: "content", label: "内容", type: "textarea", rows: 10, full: true },
        { key: "author", label: "記録者", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  // === 緊急・リスク ===
  emergency_plan: {
    sections: [
      { title: "緊急時対応計画", fields: [
        { key: "plan_date", label: "作成日", type: "date" },
        { key: "reviewer", label: "主治医確認日", type: "date" },
      ]},
      { title: "想定される緊急事態", fields: [
        { key: "anticipated_situations", label: "予測される緊急状況", type: "textarea", rows: 4, full: true },
      ]},
      { title: "連絡体制", fields: [
        { key: "contact_1", label: "第1連絡先(家族等)", type: "text", full: true },
        { key: "contact_2", label: "第2連絡先", type: "text", full: true },
        { key: "doctor_contact", label: "主治医連絡先", type: "text", full: true },
        { key: "station_contact", label: "訪問看護ステーション 24h連絡先", type: "text", full: true },
        { key: "ambulance_criteria", label: "救急搬送判断基準", type: "textarea", rows: 3, full: true },
      ]},
      { title: "対応手順", fields: [
        { key: "response_steps", label: "緊急時の対応手順", type: "textarea", rows: 6, full: true },
        { key: "evacuation_route", label: "避難経路・避難先", type: "textarea", rows: 2, full: true },
      ]},
      { title: "災害時対応", fields: [
        { key: "disaster_plan", label: "災害時(地震・台風等)の対応", type: "textarea", rows: 4, full: true },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  accident_report: {
    sections: [
      { title: "事故報告 基本情報", fields: [
        { key: "report_date", label: "報告書作成日", type: "date" },
        { key: "case_no", label: "事故番号", type: "text" },
        { key: "accident_date", label: "事故発生日", type: "date" },
        { key: "accident_time", label: "発生時刻", type: "text" },
        { key: "discovery_time", label: "発見時刻", type: "text" },
        { key: "location", label: "発生場所", type: "text", full: true },
        { key: "involved_staff", label: "対応スタッフ(複数可)", type: "textarea", rows: 2, full: true },
        { key: "accident_type", label: "事故種別", type: "select", options: ["転倒", "転落", "誤薬", "誤嚥", "熱傷", "ルート抜去", "感染", "医療事故", "対物事故", "その他"] },
        { key: "severity", label: "重大度(ハインリッヒ)", type: "select", options: ["重大事故(死亡・後遺症)", "中程度(入院・治療)", "軽微(処置のみ)", "ヒヤリハット相当"] },
      ]},
      { title: "事故状況", fields: [
        { key: "situation", label: "発生時の状況(時系列で記載)", type: "textarea", rows: 6, full: true },
        { key: "patient_condition", label: "事故時の利用者の状態", type: "textarea", rows: 3, full: true },
        { key: "injury", label: "傷害の程度・部位", type: "textarea", rows: 3, full: true },
        { key: "immediate_response", label: "直後の対応(処置・救急要請等)", type: "textarea", rows: 4, full: true },
        { key: "hospital_taken_to", label: "搬送先医療機関(該当時)", type: "text", full: true },
      ]},
      { title: "原因分析・再発防止", fields: [
        { key: "cause_analysis", label: "原因分析(人的・環境・システム要因)", type: "textarea", rows: 5, full: true },
        { key: "prevention", label: "再発防止策", type: "textarea", rows: 5, full: true },
        { key: "prevention_implemented", label: "再発防止策を実施済み", type: "check" },
        { key: "prevention_implement_date", label: "再発防止策 実施日", type: "date" },
      ]},
      { title: "報告・連絡", fields: [
        { key: "reported_to_family", label: "家族への報告日時", type: "text" },
        { key: "family_response", label: "家族の反応・要望", type: "textarea", rows: 2, full: true },
        { key: "reported_to_doctor", label: "主治医への報告日", type: "date" },
        { key: "reported_to_caremgr", label: "ケアマネへの報告日", type: "date" },
        { key: "reported_to_insurance", label: "保険者・行政への報告日", type: "date" },
        { key: "external_report_required", label: "行政への届出が必要(死亡・骨折等)", type: "check" },
        { key: "insurance_claim", label: "賠償保険請求の有無", type: "select", options: ["なし", "検討中", "請求予定", "請求済"] },
      ]},
      { title: "報告者・確認", fields: [
        { key: "reporter", label: "報告者", type: "text" },
        { key: "manager_confirmed", label: "管理者確認", type: "text" },
        { key: "confirmed_date", label: "管理者確認日", type: "date" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  hiyari_hatto: {
    sections: [
      { title: "ヒヤリ・ハット 基本", fields: [
        { key: "report_date", label: "報告日", type: "date" },
        { key: "case_no", label: "管理番号", type: "text" },
        { key: "occur_date", label: "発生日時", type: "date" },
        { key: "occur_time", label: "発生時刻", type: "text" },
        { key: "location", label: "発生場所", type: "text", full: true },
        { key: "staff", label: "関係スタッフ", type: "text" },
        { key: "level", label: "影響レベル", type: "select", options: ["レベル0(気付き)", "レベル1(影響なし)", "レベル2(観察強化要)", "レベル3a(軽処置)", "レベル3b(濃厚処置)"] },
        { key: "category", label: "種類", type: "select", options: ["転倒・転落", "服薬", "医療処置", "誤嚥・窒息", "感染", "情報伝達", "機器・物品", "コミュニケーション", "その他"] },
      ]},
      { title: "状況", fields: [
        { key: "situation", label: "状況の詳細", type: "textarea", rows: 5, full: true },
        { key: "result_if_continued", label: "そのまま進んでいたら起こり得た結果", type: "textarea", rows: 3, full: true },
      ]},
      { title: "SHELL要因分析", fields: [
        { key: "factor_software", label: "Software(マニュアル・手順)要因", type: "textarea", rows: 2, full: true },
        { key: "factor_hardware", label: "Hardware(機器・物品)要因", type: "textarea", rows: 2, full: true },
        { key: "factor_environment", label: "Environment(環境)要因", type: "textarea", rows: 2, full: true },
        { key: "factor_liveware", label: "Liveware(本人・他者)要因", type: "textarea", rows: 2, full: true },
        { key: "cause", label: "総合的な発生要因(まとめ)", type: "textarea", rows: 3, full: true },
      ]},
      { title: "改善策", fields: [
        { key: "countermeasure", label: "改善策・再発防止策", type: "textarea", rows: 4, full: true },
        { key: "implemented", label: "改善策を実施済み", type: "check" },
        { key: "implement_date", label: "実施日", type: "date" },
        { key: "shared_with_team", label: "事業所内で共有済み(申し送り・会議)", type: "check" },
      ]},
      { title: "報告者・確認", fields: [
        { key: "reporter", label: "報告者", type: "text" },
        { key: "manager_confirmed", label: "管理者確認", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  complaint: {
    sections: [
      { title: "苦情対応", fields: [
        { key: "receipt_date", label: "受付日", type: "date" },
        { key: "claimant", label: "苦情申立者(氏名・続柄)", type: "text", full: true },
        { key: "channel", label: "受付方法", type: "select", options: ["電話", "来所", "書面", "メール", "その他"] },
        { key: "content", label: "苦情内容", type: "textarea", rows: 5, full: true },
        { key: "initial_response", label: "初期対応", type: "textarea", rows: 3, full: true },
        { key: "investigation", label: "調査内容", type: "textarea", rows: 4, full: true },
        { key: "resolution", label: "対応・改善策", type: "textarea", rows: 4, full: true },
        { key: "resolution_date", label: "解決日", type: "date" },
        { key: "status", label: "対応状況", type: "select", options: ["受付", "調査中", "対応中", "解決", "継続対応"] },
        { key: "handler", label: "対応担当者", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  // === 看取り・終了 ===
  end_of_life_consent: {
    sections: [
      { title: "看取り同意 基本情報", fields: [
        { key: "consent_date", label: "同意日", type: "date" },
        { key: "primary_diagnosis", label: "主疾患・予後", type: "textarea", rows: 2, full: true },
        { key: "stage", label: "予後段階", type: "select", options: ["告知済(年単位)", "告知済(月単位)", "告知済(週単位)", "予後数日", "ターミナル期"] },
        { key: "place_of_care", label: "看取り希望場所", type: "select", options: ["自宅", "施設", "病院", "未定"] },
        { key: "second_choice_place", label: "第二希望(状況により変更時)", type: "select", options: ["自宅", "施設", "病院", "未定"] },
      ]},
      { title: "ACP(人生会議)実施内容", fields: [
        { key: "acp_date", label: "ACP実施日", type: "date" },
        { key: "acp_participants", label: "参加者(本人・家族・医師等)", type: "textarea", rows: 2, full: true },
        { key: "patient_values", label: "本人が大切にしたい価値観・希望", type: "textarea", rows: 4, full: true },
        { key: "policy", label: "看取りの基本方針", type: "textarea", rows: 4, full: true },
      ]},
      { title: "延命処置の意思", fields: [
        { key: "dnar", label: "DNAR(蘇生処置を希望しない)", type: "check" },
        { key: "no_intubation", label: "気管挿管を希望しない", type: "check" },
        { key: "no_ventilator", label: "人工呼吸器装着を希望しない", type: "check" },
        { key: "no_artificial_nutrition", label: "人工栄養(胃ろう・経管)を希望しない", type: "check" },
        { key: "no_iv_hydration", label: "輸液による延命を希望しない", type: "check" },
        { key: "advance_directive", label: "延命処置に関する本人の意思 自由記述", type: "textarea", rows: 4, full: true },
        { key: "advance_directive_doc", label: "事前指示書(リビングウィル等)の有無", type: "select", options: ["なし", "あり(本人保管)", "あり(家族保管)", "あり(主治医保管)"] },
      ]},
      { title: "家族・関係者", fields: [
        { key: "family_wishes", label: "家族の希望・不安事項", type: "textarea", rows: 4, full: true },
        { key: "family_decision_maker", label: "代理意思決定者(氏名・続柄)", type: "text", full: true },
        { key: "religion_culture", label: "宗教的・文化的配慮事項", type: "textarea", rows: 2, full: true },
      ]},
      { title: "ケア体制", fields: [
        { key: "doctor_coop", label: "主治医との連携事項(往診頻度等)", type: "textarea", rows: 3, full: true },
        { key: "death_pronouncement_doctor", label: "死亡確認医師(予定)", type: "text" },
        { key: "agree_palliative", label: "苦痛緩和を主とするケアに同意する", type: "check" },
        { key: "agree_home_death", label: "在宅看取りに同意する", type: "check" },
        { key: "review_trigger", label: "方針見直しのきっかけ(状態変化時等)", type: "textarea", rows: 2, full: true },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  death_record: {
    sections: [
      { title: "死亡時記録", fields: [
        { key: "death_date", label: "死亡日時", type: "date" },
        { key: "death_time", label: "時刻", type: "text" },
        { key: "death_place", label: "死亡場所", type: "text", full: true },
        { key: "confirmed_by", label: "死亡確認医師", type: "text" },
        { key: "death_cause", label: "死因(死亡診断書記載)", type: "textarea", rows: 2, full: true },
        { key: "last_visit", label: "最終訪問日時", type: "text" },
        { key: "condition_before_death", label: "死亡直前の状態", type: "textarea", rows: 4, full: true },
        { key: "response", label: "対応内容(連絡・ケア)", type: "textarea", rows: 5, full: true },
        { key: "family_status", label: "家族の様子・グリーフケア", type: "textarea", rows: 3, full: true },
        { key: "recorder", label: "記録者", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },

  service_end: {
    sections: [
      { title: "サービス終了記録", fields: [
        { key: "end_date", label: "終了日", type: "date" },
        { key: "reason", label: "終了理由", type: "select", options: ["入院", "施設入所", "死亡", "転居", "利用者の意向", "契約終了", "その他"] },
        { key: "reason_detail", label: "理由詳細", type: "textarea", rows: 3, full: true },
        { key: "final_condition", label: "終了時の状態", type: "textarea", rows: 4, full: true },
        { key: "handover_target", label: "引継ぎ先", type: "text", full: true },
        { key: "handover_content", label: "引継ぎ内容", type: "textarea", rows: 5, full: true },
        { key: "used_period", label: "利用期間", type: "text" },
        { key: "total_visits", label: "総訪問回数", type: "number" },
        { key: "closer", label: "終了処理担当者", type: "text" },
      ]},
      { title: "署名", fields: signatureFields },
    ],
  },
};

// Fallback generic schema for types without specific schema
export const GENERIC_SCHEMA = {
  sections: [
    { title: "内容", fields: [
      { key: "date", label: "日付", type: "date" },
      { key: "purpose", label: "目的", type: "text", full: true },
      { key: "content", label: "内容", type: "textarea", rows: 6, full: true },
      { key: "notes", label: "備考", type: "textarea", rows: 3, full: true },
    ]},
  ],
};

// Helper: does a schema already have a signature section?
const hasSignatureSection = (schema) =>
  (schema.sections || []).some((sec) =>
    (sec.fields || []).some((f) => f.type === "signature"),
  );

// Public accessor — always ensures every document has a "署名" section with signature pads.
export const getSchema = (docType) => {
  const base = DOC_SCHEMAS[docType] || GENERIC_SCHEMA;
  if (hasSignatureSection(base)) return base;
  return {
    ...base,
    sections: [
      ...(base.sections || []),
      { title: "署名", fields: signatureFields },
    ],
  };
};
